import { axios } from "@/lib/axios";
import { Sponsor } from "@/features/Sponsors/types";

export const getSponsor = (id: string): Promise<Sponsor> => {
    return axios.get(`/api/admin/sponsor/${id}`);
};